// extracted by mini-css-extract-plugin
module.exports = {"cases":"styles-module--cases--3xAB5","selected":"styles-module--selected--1iBHx"};